import React, { useState, useEffect } from 'react';
import Axios from 'axios';

const HclSatheeDashboard = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const API_URL = process.env.REACT_APP_API_URL;

    useEffect(() => {
        Axios.get(`${API_URL}/sathee/analytics`, { headers: { Authorization: localStorage.getItem('token') } })
            .then(res => {
                if (res.data.status === 'success') setData(res.data.data);
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
            });
    }, [API_URL]);

    if (loading) return <div>Loading Analytics...</div>;
    if (!data) return <div>Failed to load data</div>;

    const Card = ({ title, value, icon, color }) => (
        <div style={{ background: '#fff', padding: 20, borderRadius: 12, boxShadow: '0 4px 15px rgba(0,0,0,0.05)', display: 'flex', alignItems: 'center', gap: 15, borderLeft: `5px solid ${color}` }}>
            <div style={{ width: 50, height: 50, borderRadius: '50%', background: `${color}20`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <i className={`bx ${icon}`} style={{ fontSize: 24, color: color }}></i>
            </div>
            <div>
                <h3 style={{ margin: 0, fontSize: 24, color: '#2d3748' }}>{value}</h3>
                <p style={{ margin: 0, fontSize: 13, color: '#718096', fontWeight: 600 }}>{title}</p>
            </div>
        </div>
    );

    return (
        <div style={{ padding: 20 }}>
            <h2 style={{ marginBottom: 20, color: '#1a202c' }}>HCL SATHEE Dashboard</h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 20, marginBottom: 30 }}>
                <Card title="Total Students" value={data.totalStudents} icon="bx-user" color="#4299e1" />
                <Card title="Total Kendras" value={data.totalKendras} icon="bx-buildings" color="#48bb78" />
                <Card title="JEE Aspirants" value={data.jeeStudents} icon="bx-book-open" color="#ed8936" />
                <Card title="NEET Aspirants" value={data.neetStudents} icon="bx-pulse" color="#f56565" />
                <Card title="CUET Aspirants" value={data.cuetStudents} icon="bx-bulb" color="#9f7aea" />
                <Card title="Board Exam" value={data.boardStudents} icon="bx-pencil" color="#38b2ac" />
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 20 }}>
                <div style={{ background: '#fff', padding: 20, borderRadius: 12, boxShadow: '0 4px 15px rgba(0,0,0,0.05)' }}>
                    <h4>Gender Distribution</h4>
                    {data.genderDist && data.genderDist.map(g => (
                        <div key={g.gender} style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', borderBottom: '1px solid #edf2f7' }}>
                            <span>{g.gender || 'Unknown'}</span>
                            <strong>{g.count}</strong>
                        </div>
                    ))}
                </div>
                <div style={{ background: '#fff', padding: 20, borderRadius: 12, boxShadow: '0 4px 15px rgba(0,0,0,0.05)' }}>
                    <h4>School Type Distribution</h4>
                    {data.schoolTypeDist && data.schoolTypeDist.map(s => (
                        <div key={s.school_type} style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', borderBottom: '1px solid #edf2f7' }}>
                            <span>{s.school_type || 'Unknown'}</span>
                            <strong>{s.count}</strong>
                        </div>
                    ))}
                </div>
                <div style={{ background: '#fff', padding: 20, borderRadius: 12, boxShadow: '0 4px 15px rgba(0,0,0,0.05)' }}>
                    <h4>Social Group Distribution</h4>
                    {data.socialGroupDist && data.socialGroupDist.map(s => (
                        <div key={s.social_group} style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', borderBottom: '1px solid #edf2f7' }}>
                            <span>{s.social_group || 'Unknown'}</span>
                            <strong>{s.count}</strong>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default HclSatheeDashboard;
